/**
 * Datasources Store
 *
 * Manages datasources status information for administration.
 */

import { type GetStoreState, type SetStoreState, createStore } from '@/stores/createStore';
import type { DatasourcesStatusOutputV1 } from '@seeqdev/api/model/DatasourcesStatusOutputV1';

export interface DatasourcesState {
  datasources: DatasourcesStatusOutputV1 | undefined;
}

const initialState: DatasourcesState = {
  datasources: undefined,
};

const datasourcesActionsFactory = (set: SetStoreState<DatasourcesState>, _get: GetStoreState<DatasourcesState>) => ({
  /**
   * Set the datasources status
   */
  setDatasources: (datasources: DatasourcesStatusOutputV1) => {
    set((draft: DatasourcesState) => {
      draft.datasources = datasources;
    });
  },

  /**
   * Reset store to initial state
   */
  reset: () => {
    set(() => initialState);
  },
});

const [DatasourcesStoreProvider, useDatasourcesStoreInstance, useDatasourcesSelector] = createStore(
  'sqDatasourcesStore',
  initialState,
  datasourcesActionsFactory,
);

export { DatasourcesStoreProvider };

/**
 * Get datasources actions
 */
export const useDatasourcesActions = () => useDatasourcesStoreInstance().actions;

/**
 * Get datasources state
 */
export const useDatasources = () => useDatasourcesSelector((state) => state.datasources);
